// extracted by mini-css-extract-plugin
module.exports = {"page":"App_page__1GWvf","onboardingWrap":"App_onboardingWrap__2bsGb","onboardingWarning":"App_onboardingWarning__10Bg_"};